import React from 'react';
import { useSelector } from 'react-redux';
import { isBreakpointSmallOrBelow, useBreakpoint } from '@noths/polaris-client-ribbons-base';

import type { ReduxApplicationState } from 'src/redux/combinedReducer';
import { trackTrustCarouselImpression } from '../tracking/trustCarouselEvents';
import { TrustCarousel } from './TrustCarousel';

export const TrustCarouselWithTracking = () => {
  const breakpoint = useBreakpoint({ initializeWithLarge: true });
  const trustItems = useSelector((state: ReduxApplicationState) => state.content.trustItems);

  const onVisible = (visibleHeadingText: string) => {
    if (!isBreakpointSmallOrBelow(breakpoint)) {
      trackTrustCarouselImpression(visibleHeadingText);
    }
  };

  const onItemVisible = (visibleHeadingText: string) => {
    if (isBreakpointSmallOrBelow(breakpoint)) {
      trackTrustCarouselImpression(visibleHeadingText);
    }
  };

  return <TrustCarousel items={trustItems} onItemVisible={onItemVisible} onVisible={onVisible} />;
};
